// extracted by mini-css-extract-plugin
module.exports = {"buttonBlock":"styles_buttonBlock__18cGy","textAreaBlock":"styles_textAreaBlock__2v8xX"};